export const mapNullableNumberToNumber = (
  num: number | null | undefined,
): number | undefined => {
  return num ?? undefined;
};
